/* eslint-disable no-magic-numbers */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-useless-return */
/* eslint-disable max-depth */
/* eslint-disable prefer-template */
/* eslint-disable no-return-assign */
/* eslint-disable prefer-const */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-unused-expressions */
/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable no-var */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable max-params */
/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { Component, input, output } from '@angular/core';
import { IAgentChipList } from '../../interfaces/IAgentChatInterface';

/**
 * Chip List Component
 * 
 * Displays a list of interactive suggestion chips for user selection.
 * Each chip can trigger an action or navigate to a URL.
 * 
 * @example
 * <nalco-agent-chip-list 
 *   [chipList]="suggestions"
 *   (chipSelectionChangeEmitter)="handleChipClick($event)">
 * </nalco-agent-chip-list>
 */
@Component({
  selector: 'nalco-agent-chip-list',
  templateUrl: './chip-list.component.html',
  styleUrl: './chip-list.component.scss',
  standalone: false
})
export class ChipListComponent {
  /** Array of chip items to display */
  readonly chipList = input<IAgentChipList[]>([]);

  /** Emits when a chip is selected by the user */
  readonly chipSelectionChangeEmitter = output<IAgentChipList>();

  /**
   * Handles the selection of a chip from the chip list.
   * 
   * @param chip - The chip that was selected by the user
   * @returns void
   * 
   * @emits chipSelectionChangeEmitter - Emits the selected chip data to parent components
   */
  public onChipSelection(chip: IAgentChipList): void {
    // Emit the selected chip or handle the selection logic
    this.chipSelectionChangeEmitter.emit(chip);
  }

  /**
   * Handles navigation selection by opening the specified link in a new browser tab.
   * 
   * @param navigationLink - The URL string to navigate to
   * @public
   */
  public onNavigationSelected(navigationLink: string) {
    if (navigationLink) {
      window.open(navigationLink, '_blank');
    }
  }
}
